'use strict';
define([], function () {
    return {
        templateUrl: 'app/modules/project/components/crawl-session/crawl-session.html',
        bindings: {
            /* Crawl session payload: start, end, duration and downloaded resources. */
            session: '<',
            /* Needed by the resources count, which links to the Page Explorer. */
            projectId: '<',
        },
    };
});
